import { useShouldImport } from '@/vdp/VehicleDetailsContainer/hooks';
import {
  useGetIsWIPVehicle,
  useIsNewVehicle
} from '~/context/vdp/VehicleContext';
import useIsInInspectionExperiment from '../useIsInInspectionExperiment';

export default function useShowInspection() {
  const { importRecalls } = useShouldImport();
  const isNewVehicle = useIsNewVehicle();
  const isWIPVehicle = useGetIsWIPVehicle();

  const isInInspectionExperiment = useIsInInspectionExperiment();

  return isInInspectionExperiment
    ? true
    : !isWIPVehicle && (!isNewVehicle || importRecalls);
}
